import {useState} from 'react'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import commonStyles from '../styles.module.scss'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import {Text, Button, Modal} from 'common/components'
import { VariationJournalForm } from 'modules/project'
import {
  MilestoneAction,
  MilestoneCheck,
  RequestDecline,
  useAcceptRequestStatus,
  isAllMilestonesPassed,
  // isMilestonePassed,
  // isFirstManagerActionsChecked,
  CheckActionsProps,
  MilestoneCheckProps,
} from '..'

export default function ManagerCheckActions({
  role,
  request,
  isRequestLoading,
}: CheckActionsProps) {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const navigate = useNavigate()
  const {
    mutate: acceptRequestStatus,
    isMutating: isAcceptRequestStatusMutating,
  } = useAcceptRequestStatus(request.uuid)

  const handleStatusAccept = () => acceptRequestStatus()

  // const hasAssignBorrowerCheck = request.milestones.some(
  //   (milestone: any) => milestone.type === 'borrower-assigned'
  // )
  // const hasUpdateForecastCheck = request.milestones.some(
  //   (milestone: any) => milestone.type === 'forecast-updated'
  // )
  // const isLastActionsDisabled = !isFirstManagerActionsChecked(request)
  const isStatusAcceptDisabled = // isLastActionsDisabled ||
    isRequestLoading ||
    (!isAllMilestonesPassed(request, [
      'fees-checked',
      'documents-checked',
    ]))

  const isNotAllowed = (!permissions?.includes('edit journal request (lm check)'))
  // console.log(request)
  return (
    <div className={commonStyles.checkActions}>
      <div className={commonStyles.checkActionsBlock}>
        <Text size="xs">
          <Text as="span" weight="demiBold">
            Lending manager
          </Text>
          <br />
          responsible to do:
        </Text>
        <div className={commonStyles.checkActionsMilestones}>
          <div>
            <FeesCheck
              tag="journal"
              type="fees-checked"
              request={request}
              disabled={isNotAllowed}
            />
            <MilestoneCheck
              tag="journal"
              type="documents-checked"
              request={request}
              disabled={isNotAllowed}
              onArrowClick={() => navigate('documents')}
            />
          </div>
        </div>
      </div>
      { !isNotAllowed && (
        <div>
          <Button
            className={commonStyles.checkActionsButton}
            loading={isAcceptRequestStatusMutating}
            disabled={isStatusAcceptDisabled}
            onClick={handleStatusAccept}
          >
            Check has been done
          </Button>
          <RequestDecline
            requestUuid={request.uuid}
            requestStatus={request.status}
            disabled={isRequestLoading}
            tag="journal"
          />
        </div>
      )}
    </div>
  )
}

const FeesCheck = ({request, disabled}: MilestoneCheckProps) => {
  const [open, setOpen] = useState<boolean>(false)
  const handleCheck = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    (
      !request?.milestones ||
      !request?.project?.uuid ||
      !request?.type ||
      !request?.amount
    ) ? null :
    <>
    <MilestoneAction
      tag="journal"
      type="fees-checked"
      milestones={request.milestones}
      disabled={disabled}
      onClick={handleCheck}
    />

    <Modal narrow
      title={'Journal'}
      width={485}
      open={open}
      onCancel={handleClose}
    >
      <VariationJournalForm
        onClose={handleClose}
        projectUuid={request.project.uuid}
        initialValues={{
          uuid: request.uuid,
          type: request.type,
          date: dayjs(request.date).toDate(),
          amount: request.amount,
          comment: request.comment,
          statementNote: request.statementNote,
        }}
      />
    </Modal>


    </>
  )
}
